export class ResponseModel {
    isSuccess: boolean;
    message: string;
    data: any;
    exception?: object;
    dataCount?: number;
    //
    requestShipmentNumber: string;
    businessUserCode: string;
    pickUserCode: string;
    pickUserFullName: string;
    senderCode: string;
    referenceCustomerCode: string;
    referenceCustomerName: string;
    receiverCode: string;
    structureName: string;
    structureCode: string;
    serviceCode: string;
    serviceName: string;
    parrentShipmentNumber: string;
    paymentTypeCode: string;
    paymentTypeName: string;
    fromProvinceName: string;
    fromProvinceCode: string;
    fromDistrictName: string;
    fromDistrictCode: string;
    fromWardCode: string;
    fromWardName: string;
    toProvinceName: string;
    toProvinceCode: string;
    toDistrictName: string;
    toDistrictCode: string;
    toWardCode: string;
    toWardName: string;
    fromHubCode: string;
    fromHubName: string;
    toHubCode: string;
    toHubName: string;
}